export const state = {
  isSavingSnippetLoading: false,
  isDestroyingSnippetLoading: false,
  snippets: [],
  mode: '',
  modalSnippet: false,
  hit: {},
  hitIdx: null,
  pageNum: null,
  filters: [],
  query: '',
  actionDateEnd: '',
  actionDateStart: '',
  snippet: {
    description: '',
  },
  snippetsCount: null,
  editSnippet: false,
  modalConfirm: false,
  activeSnippetIds: [],
  activeSnippetHashes: [],
  snippetExistsArray: [],
};
